<template>
  <div class="style">
    <menuTop/>
    <topo/>
    <logos/>
    <typography/>
    <grid/>
    <spaces/>
    <colors/>
    <icons/>
    <buttons/>
    <tags/>
    <inputs/>

    <div class="size margin">
      <div class="margin-top-100">
        <titleComponent value="Conquistas" mark="01" color="background-yellow" />
        <conquistas/>
      </div>

      <div class="margin-top-100">
        <titleComponent value="Books" mark="01" color="background-yellow" />
        <booksList :data="books" />
      </div>

      <div class="margin-top-100">
        <titleComponent value="Unidades" mark="01" color="background-yellow" />
        <suasUnidades :data="units" />
      </div>

      <div class="margin-top-100">
        <titleComponent value="Personagens" mark="01" color="background-yellow" />
        <personagens :data="user" />
      </div>

      <div class="margin-top-100">
        <titleComponent value="Palavras" mark="01" color="background-yellow" />
        <palavrasTranslate :data="words" />
      </div>

    </div>

    <telas style="margin-top: 100px" />
    <rodapeFinal style="margin-top: 100px" />
  </div>
</template>

<script>
  import titleComponent from '@/components/titleComponent'
  import topo from '@/components/topo'
  import menuTop from '@/components/header'
  import logos from '@/components/styleguide/logos'
  import colors from '@/components/styleguide/colors'
  import typography from '@/components/styleguide/typography'
  import inputs from '@/components/styleguide/inputs'
  import tags from '@/components/styleguide/tags'
  import grid from '@/components/styleguide/grid'
  import spaces from '@/components/styleguide/spaces'
  import icons from '@/components/styleguide/icons'
  import buttons from '@/components/styleguide/buttons'
  import palavrasTranslate from '@/components/words'
  import conquistas from '@/components/achievements'
  import suasUnidades from '@/components/units'
  import booksList from '@/components/books'
  import personagens from '@/components/characters'
  import telas from '@/components/styleguide/telas'
  import rodapeFinal from '@/components/footer'

  export default {
    components: {
      titleComponent,
      topo,
      menuTop,
      logos,
      colors,
      typography,
      rodapeFinal,
      inputs,
      tags,
      grid,
      spaces,
      telas,
      icons,
      buttons,
      palavrasTranslate,
      conquistas,
      suasUnidades,
      booksList,
      personagens
    },
    data () {
      return {
        user: [{
          id: 1,
          name: 'Joao Augusto',
          class: 'Apprentice',
          level: 1,
          points: 8000,
          tag: 'one'
        }, {
          id: 2,
          name: 'Joao Augusto',
          class: 'Planner',
          level: 2,
          points: 2808,
          tag: 'two'
        }, {
          id: 3,
          name: 'Joao Augusto',
          class: 'Planner',
          level: 3,
          points: 2808,
          tag: 'three'
        }, {
          id: 4,
          name: 'Joao Augusto',
          class: 'Planner',
          level: 4,
          points: 2808,
          tag: 'four'
        }, {
          id: 5,
          name: 'Joao Augusto',
          class: 'Planner',
          level: 5,
          points: 2808,
          tag: 'five'
        }, {
          id: 6,
          name: 'Joao Augusto',
          class: 'Planner',
          level: 6,
          points: 2808,
          tag: 'six'
        }],
        books: [{
          id: 1,
          title: 'One',
          description: 'Etiam pulvinar varius velit sed volutpat. Sed auctor euismod quam ac fermentum.',
          page: 'book/one',
          class: 'gradient-books-one'
        }, {
          id: 2,
          title: 'Two',
          description: 'Etiam pulvinar varius velit sed volutpat. Sed auctor euismod quam ac fermentum.',
          page: 'book/Two',
          class: 'gradient-books-two'
        }, {
          id: 3,
          title: 'Three',
          description: 'Etiam pulvinar varius velit sed volutpat. Sed auctor euismod quam ac fermentum.',
          page: 'book/three',
          class: 'gradient-books-three'
        }],
        words: [{
          id: 1,
          key: 'Orange',
          translate: 'Laranja',
          type: 'adjective'
        }, {
          id: 2,
          key: 'Boy',
          translate: 'Menino',
          type: 'adjective'
        }, {
          id: 3,
          key: 'Girl',
          translate: 'Menina',
          type: 'adjective'
        }, {
          id: 4,
          key: 'Orange',
          translate: 'Laranja',
          type: 'adjective'
        }, {
          id: 5,
          key: 'Boy',
          translate: 'Menino',
          type: 'adjective'
        }, {
          id: 6,
          key: 'Girl',
          translate: 'Menina',
          type: 'adjective'
        }, {
          id: 7,
          key: 'Orange',
          translate: 'Laranja',
          type: 'adjective'
        }, {
          id: 8,
          key: 'Boy',
          translate: 'Menino',
          type: 'adjective'
        }, {
          id: 9,
          key: 'Girl',
          translate: 'Menina',
          type: 'adjective'
        }, {
          id: 10,
          key: 'Orange',
          translate: 'Laranja',
          type: 'adjective'
        }, {
          id: 11,
          key: 'Boy',
          translate: 'Menino',
          type: 'adjective'
        }, {
          id: 12,
          key: 'Girl',
          translate: 'Menina',
          type: 'adjective'
        }],
        conquistas: [{
          id: 1,
          name: 'Diamond',
          image: 'diamond',
          color: '#D67E00',
          ok: true
        }, {
          id: 2,
          name: 'Baloon',
          image: 'text',
          color: '#2CA3A9',
          ok: true
        }, {
          id: 3,
          name: 'Search',
          image: 'star',
          color: '#ff4455',
          ok: true
        }, {
          id: 4,
          name: 'Clock',
          image: 'star',
          color: '#8AD955',
          ok: true
        }, {
          id: 5,
          name: 'Paint',
          image: 'star',
          color: '#ff4455',
          ok: false
        }, {
          id: 6,
          name: 'Paint',
          image: 'star',
          color: '#ff4455',
          ok: false
        }, {
          id: 7,
          name: 'Magic',
          image: 'star',
          color: '#ff4455',
          ok: false
        }, {
          id: 8,
          name: 'Computer',
          image: 'star',
          color: '#ff4455',
          ok: false
        }, {
          id: 9,
          name: 'Money',
          image: 'star',
          color: '#ff4455',
          ok: false
        }, {
          id: 10,
          name: 'Disk',
          image: 'star',
          color: '#ff4455',
          ok: false
        }],
        units: [{
          id: 1,
          title: 'Single verbs initial',
          level: 3,
          finished: true,
          presential: false,
          cor1: '#FF9C00',
          cor2: '#FF0000'
        }, {
          id: 2,
          title: 'Single verbs initial',
          level: 3,
          finished: true,
          presential: false,
          cor1: '#1AB8EA',
          cor2: '#FF00A2'
        }, {
          id: 3,
          title: 'Single verbs initial',
          level: 2,
          finished: false,
          presential: false,
          cor1: '#E12F67',
          cor2: '#8D00FF'
        }, {
          id: 4,
          title: 'Single verbs initial',
          level: 0,
          finished: false,
          presential: true,
          cor1: '#6FBE15',
          cor2: '#00F0FF'
        }, {
          id: 5,
          title: 'Single verbs initial',
          level: 0,
          finished: false,
          presential: true,
          cor1: '#FF9C00',
          cor2: '#FF0000'
        }, {
          id: 6,
          title: 'Single verbs initial',
          level: 0,
          finished: false,
          presential: true,
          cor1: '#1AB8EA',
          cor2: '#FF00A2'
        }, {
          id: 7,
          title: 'Single verbs initial',
          level: 0,
          finished: false,
          presential: true,
          cor1: '#E12F67',
          cor2: '#8D00FF'
        }, {
          id: 8,
          title: 'Single verbs initial',
          level: 0,
          finished: false,
          presential: true,
          cor1: '#6FBE15',
          cor2: '#00F0FF'
        }]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .style {
    background: #fff;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/styleguide/index.vue